var map = {
	"./aparthotelclub/ic_verified_badge_medium.svg": 9729,
	"./beachful/ic_verified_badge_medium.svg": 94405,
	"./castlepedia/ic_verified_badge_medium.svg": 48288,
	"./cocktayl/ic_verified_badge_medium.svg": 87985,
	"./ic_verified_badge_medium.svg": 9368,
	"./luxresortclub/ic_verified_badge_medium.svg": 64544,
	"./parkful/ic_verified_badge_medium.svg": 21610,
	"./prefabworld/ic_verified_badge_medium.svg": 90565,
	"./rooftopclub/ic_verified_badge_medium.svg": 3491,
	"./spaclub/ic_verified_badge_medium.svg": 1907,
	"./worldcasino/ic_verified_badge_medium.svg": 85248,
	"./zoopedia/ic_verified_badge_medium.svg": 3226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40119;